/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `view_tenant` - View Tenant
 * * `manage_tenant` - Manage Tenant
 * * `add_partner` - Add Partner
 * * `remove_partner` - Remove Partner
 * * `view_users` - View Users
 * * `create_users` - Create Users
 * * `update_users` - Update Users
 * * `delete_users` - Delete Users
 * * `view_licenses` - View Licenses
 * * `activate_license` - Activate License
 * * `activate_trial` - Activate Trial License
 * * `transfer_license` - Transfer License
 * * `use_enterprise_skus` - Use Enterprise SKUs
 * * `create_provisional_license` - Create Provisional License
 * * `view_devices` - View Devices
 * * `manage_devices` - Manage Devices
 * * `dissociate_devices` - Dissociate Devices
 * * `view_policy` - View Policy
 * * `create_policy` - Create Policy
 * * `view_idm_ui` - Access Wolf Portal UI
 * @export
 */
export const TenantPermission = {
    ViewTenant: 'view_tenant',
    ManageTenant: 'manage_tenant',
    AddPartner: 'add_partner',
    RemovePartner: 'remove_partner',
    ViewUsers: 'view_users',
    CreateUsers: 'create_users',
    UpdateUsers: 'update_users',
    DeleteUsers: 'delete_users',
    ViewLicenses: 'view_licenses',
    ActivateLicense: 'activate_license',
    ActivateTrial: 'activate_trial',
    TransferLicense: 'transfer_license',
    UseEnterpriseSkus: 'use_enterprise_skus',
    CreateProvisionalLicense: 'create_provisional_license',
    ViewDevices: 'view_devices',
    ManageDevices: 'manage_devices',
    DissociateDevices: 'dissociate_devices',
    ViewPolicy: 'view_policy',
    CreatePolicy: 'create_policy',
    ViewIdmUi: 'view_idm_ui'
} as const;
export type TenantPermission = typeof TenantPermission[keyof typeof TenantPermission];


export function TenantPermissionFromJSON(json: any): TenantPermission {
    return TenantPermissionFromJSONTyped(json, false);
}

export function TenantPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantPermission {
    return json as TenantPermission;
}

export function TenantPermissionToJSON(value?: TenantPermission | null): any {
    return value as any;
}

